"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[962],{

/***/ 76103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U2": function() { return /* binding */ RangeSlider; },
/* harmony export */   "I2": function() { return /* binding */ RangeSliderFilledTrack; },
/* harmony export */   "xW": function() { return /* binding */ RangeSliderThumb; },
/* harmony export */   "ug": function() { return /* binding */ RangeSliderTrack; },
/* harmony export */   "iR": function() { return /* binding */ Slider; },
/* harmony export */   "Ms": function() { return /* binding */ SliderFilledTrack; },
/* harmony export */   "jz": function() { return /* binding */ SliderMark; },
/* harmony export */   "Uj": function() { return /* binding */ SliderTrack; }
/* harmony export */ });
/* unused harmony exports RangeSliderMark, RangeSliderProvider, SliderProvider, SliderThumb, useRangeSlider, useRangeSliderContext, useSlider, useSliderContext */
/* harmony import */ var _chakra_ui_react_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7429);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47386);
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80190);
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28293);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56168);
/* harmony import */ var _chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27446);







function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function getIds(id) {
  return {
    root: "slider-root-" + id,
    getThumb: function getThumb(i) {
      return "slider-thumb-" + id + "-" + i;
    },
    getInput: function getInput(i) {
      return "slider-input-" + id + "-" + i;
    },
    track: "slider-track-" + id,
    innerTrack: "slider-filled-track-" + id,
    getMarker: function getMarker(i) {
      return "slider-marker-" + id + "-" + i;
    },
    output: "slider-output-" + id
  };
}
function orient$1(options) {
  var orientation = options.orientation,
      vertical = options.vertical,
      horizontal = options.horizontal;
  return orientation === "vertical" ? vertical : horizontal;
}
var zeroRect = {
  width: 0,
  height: 0
};
function getStyles(options) {
  var orientation = options.orientation,
      thumbPercents = options.thumbPercents,
      thumbRects = options.thumbRects,
      isReversed = options.isReversed;

  var getThumbStyle = function getThumbStyle(i) {
    return _extends({
      position: "absolute",
      userSelect: "none",
      WebkitUserSelect: "none",
      MozUserSelect: "none",
      msUserSelect: "none",
      touchAction: "none"
    }, orient$1({
      orientation: orientation,
      vertical: {
        bottom: "calc(" + thumbPercents[i] + "% - " + thumbRects[i].height / 2 + "px)"
      },
      horizontal: {
        left: "calc(" + thumbPercents[i] + "% - " + thumbRects[i].width / 2 + "px)"
      }
    }));
  };

  var size = orientation === "vertical" ? thumbRects.reduce(function (a, b) {
    return a.height > b.height ? a : b;
  }, zeroRect) : thumbRects.reduce(function (a, b) {
    return a.width > b.width ? a : b;
  }, zeroRect);

  var rootStyle = _extends({
    position: "relative",
    touchAction: "none",
    WebkitTapHighlightColor: "rgba(0,0,0,0)",
    userSelect: "none",
    outline: 0
  }, orient$1({
    orientation: orientation,
    vertical: {
      paddingLeft: size.width / 2,
      paddingRight: size.width / 2
    },
    horizontal: {
      paddingTop: size.height / 2,
      paddingBottom: size.height / 2
    }
  }));

  var trackStyle = _extends({
    position: "absolute"
  }, orient$1({
    orientation: orientation,
    vertical: {
      left: "50%",
      transform: "translateX(-50%)",
      height: "100%"
    },
    horizontal: {
      top: "50%",
      transform: "translateY(-50%)",
      width: "100%"
    }
  }));

  var isSingleThumb = thumbPercents.length === 1;
  var fallback = [0, isReversed ? 100 - thumbPercents[0] : thumbPercents[0]];
  var range = isSingleThumb ? fallback : thumbPercents;
  var start = range[0];

  if (!isSingleThumb && isReversed) {
    start = 100 - start;
  }

  var percent = Math.abs(range[range.length - 1] - range[0]);

  var innerTrackStyle = _extends({}, trackStyle, orient$1({
    orientation: orientation,
    vertical: isReversed ? {
      height: percent + "%",
      top: start + "%"
    } : {
      height: percent + "%",
      bottom: start + "%"
    },
    horizontal: isReversed ? {
      width: percent + "%",
      right: start + "%"
    } : {
      width: percent + "%",
      left: start + "%"
    }
  }));

  return {
    trackStyle: trackStyle,
    innerTrackStyle: innerTrackStyle,
    rootStyle: rootStyle,
    getThumbStyle: getThumbStyle
  };
}
function getIsReversed(options) {
  var isReversed = options.isReversed,
      direction = options.direction,
      orientation = options.orientation;

  if (direction === "ltr" || orientation === "vertical") {
    return isReversed;
  } // only flip for horizontal RTL
  // if isReserved 🔜  otherwise  🔚


  return !isReversed;
}

var _excluded$3 = ["min", "max", "onChange", "value", "defaultValue", "isReversed", "direction", "orientation", "id", "isDisabled", "isReadOnly", "onChangeStart", "onChangeEnd", "step", "getAriaValueText", "aria-valuetext", "aria-label", "aria-labelledby", "name", "focusThumbOnChange", "minStepsBetweenThumbs"],
    _excluded2 = ["index"],
    _excluded3 = ["value"],
    _excluded4 = ["index"];

/**
 * React hook that implements an accessible range slider.
 *
 * It is an alternative to `<input type="range" />`, and returns
 * prop getters for the component parts
 *
 * @see Docs     https://chakra-ui.com/docs/form/slider
 * @see WAI-ARIA https://www.w3.org/TR/wai-aria-practices-1.1/#slider
 */
function useRangeSlider(props) {
  var _props$min = props.min,
      min = _props$min === void 0 ? 0 : _props$min,
      _props$max = props.max,
      max = _props$max === void 0 ? 100 : _props$max,
      onChange = props.onChange,
      valueProp = props.value,
      defaultValue = props.defaultValue,
      isReversedProp = props.isReversed,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? "ltr" : _props$direction,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? "horizontal" : _props$orientation,
      idProp = props.id,
      isDisabled = props.isDisabled,
      isReadOnly = props.isReadOnly,
      onChangeStartProp = props.onChangeStart,
      onChangeEndProp = props.onChangeEnd,
      _props$step = props.step,
      step = _props$step === void 0 ? 1 : _props$step,
      getAriaValueTextProp = props.getAriaValueText,
      ariaValueText = props["aria-valuetext"],
      ariaLabel = props["aria-label"],
      ariaLabelledBy = props["aria-labelledby"],
      name = props.name,
      _props$focusThumbOnCh = props.focusThumbOnChange,
      focusThumbOnChange = _props$focusThumbOnCh === void 0 ? true : _props$focusThumbOnCh,
      _props$minStepsBetwee = props.minStepsBetweenThumbs,
      minStepsBetweenThumbs = _props$minStepsBetwee === void 0 ? 0 : _props$minStepsBetwee,
      htmlProps = _objectWithoutPropertiesLoose(props, _excluded$3);

  var onChangeStart = (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackRef */ .W6)(onChangeStartProp);
  var onChangeEnd = (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackRef */ .W6)(onChangeEndProp);
  var getAriaValueText = (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackRef */ .W6)(getAriaValueTextProp);
  var isReversed = getIsReversed({
    isReversed: isReversedProp,
    direction: direction,
    orientation: orientation
  });

  var _useControllableState = (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useControllableState */ .Tx)({
    value: valueProp,
    defaultValue: defaultValue != null ? defaultValue : [25, 75],
    onChange: onChange
  }),
      valueState = _useControllableState[0],
      setValue = _useControllableState[1];

  if (!Array.isArray(valueState)) {
    throw new TypeError("[range-slider] You passed an invalid value for `value` or `defaultValue`, expected `Array` but got `" + typeof valueState + "`");
  }

  var _useBoolean = (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useBoolean */ .kt)(),
      isDragging = _useBoolean[0],
      setDragging = _useBoolean[1];

  var _useBoolean2 = (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useBoolean */ .kt)(),
      isFocused = _useBoolean2[0],
      setFocused = _useBoolean2[1];

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(-1),
      activeIndex = _useState[0],
      setActiveIndex = _useState[1];

  var eventSourceRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var isInteractive = !(isDisabled || isReadOnly);
  var initialValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(valueState);
  var value = valueState.map(function (val) {
    return (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .clampValue */ .HU)(val, min, max);
  });
  var valueRef = (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useLatestRef */ .II)(value);
  var spacing = minStepsBetweenThumbs * step;
  var valueBounds = getValueBounds(value, min, max, spacing);
  var reversedValue = value.map(function (val) {
    return max - val + min;
  });
  var thumbValues = isReversed ? reversedValue : value;
  var thumbPercents = thumbValues.map(function (val) {
    return (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .valueToPercent */ .Rg)(val, min, max);
  });
  var isVertical = orientation === "vertical";

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(Array.from({
    length: value.length
  }).map(function () {
    return {
      width: 0,
      height: 0
    };
  })),
      thumbRects = _useState2[0],
      setThumbRects = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var _rootRef$current;

    if (!rootRef.current) return;
    var thumbs = Array.from((_rootRef$current = rootRef.current) == null ? void 0 : _rootRef$current.querySelectorAll("[role=slider]"));
    var rects = thumbs.map(function (el) {
      return {
        width: el.offsetWidth,
        height: el.offsetHeight
      };
    });
    if (rects.length) setThumbRects(rects);
  }, []);
  /**
   * Let's keep a reference to the slider track and thumb
   */

  var trackRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var rootRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var uuid = (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useId */ .Me)(idProp);
  var ids = getIds(uuid);
  var getValueFromPointer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (event) {
    var _event$touches$, _event$touches;

    if (!trackRef.current) return;
    eventSourceRef.current = "pointer";
    var rect = trackRef.current.getBoundingClientRect();

    var _ref = (_event$touches$ = (_event$touches = event.touches) == null ? void 0 : _event$touches[0]) != null ? _event$touches$ : event,
        clientX = _ref.clientX,
        clientY = _ref.clientY;

    var diff = isVertical ? rect.bottom - clientY : clientX - rect.left;
    var length = isVertical ? rect.height : rect.width;
    var percent = diff / length;
    if (isReversed) percent = 1 - percent;
    return (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .percentToValue */ .WS)(percent, min, max);
  }, [isVertical, isReversed, max, min]);
  var tenSteps = (max - min) / 10;
  var oneStep = step || (max - min) / 100;
  var actions = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return {
      setValueAtIndex: function setValueAtIndex(index, val) {
        if (!isInteractive) return;
        var bounds = valueBounds[index];
        val = parseFloat((0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .roundValueToStep */ .WP)(val, bounds.min, oneStep));
        val = (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .clampValue */ .HU)(val, bounds.min, bounds.max);
        var next = [].concat(value);
        next[index] = val;
        setValue(next);
      },
      setActiveIndex: setActiveIndex,
      stepUp: function stepUp(index, step) {
        if (step === void 0) {
          step = oneStep;
        }

        var valueAtIndex = value[index];
        var next = isReversed ? valueAtIndex - step : valueAtIndex + step;
        actions.setValueAtIndex(index, next);
      },
      stepDown: function stepDown(index, step) {
        if (step === void 0) {
          step = oneStep;
        }

        var valueAtIndex = value[index];
        var next = isReversed ? valueAtIndex + step : valueAtIndex - step;
        actions.setValueAtIndex(index, next);
      },
      reset: function reset() {
        return setValue(initialValue.current);
      }
    };
  }, [oneStep, value, isReversed, setValue, isInteractive, valueBounds]);
  /**
   * Keyboard interaction to ensure users can operate
   * the slider using only their keyboard.
   */

  var onKeyDown = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (event) {
    var eventKey = (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .normalizeEventKey */ .uh)(event);
    var keyMap = {
      ArrowRight: function ArrowRight() {
        return actions.stepUp(activeIndex);
      },
      ArrowUp: function ArrowUp() {
        return actions.stepUp(activeIndex);
      },
      ArrowLeft: function ArrowLeft() {
        return actions.stepDown(activeIndex);
      },
      ArrowDown: function ArrowDown() {
        return actions.stepDown(activeIndex);
      },
      PageUp: function PageUp() {
        return actions.stepUp(activeIndex, tenSteps);
      },
      PageDown: function PageDown() {
        return actions.stepDown(activeIndex, tenSteps);
      },
      Home: function Home() {
        var value = valueBounds[activeIndex].min;
        actions.setValueAtIndex(activeIndex, value);
      },
      End: function End() {
        var value = valueBounds[activeIndex].max;
        actions.setValueAtIndex(activeIndex, value);
      }
    };
    var action = keyMap[eventKey];

    if (action) {
      event.preventDefault();
      event.stopPropagation();
      action(event);
      eventSourceRef.current = "keyboard";
    }
  }, [actions, activeIndex, tenSteps, valueBounds]);
  /**
   * Compute styles for all component parts.
   */

  var _useMemo = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return getStyles({
      isReversed: isReversed,
      orientation: orientation,
      thumbRects: thumbRects,
      thumbPercents: thumbPercents
    });
  }, [isReversed, orientation, thumbPercents, thumbRects]),
      getThumbStyle = _useMemo.getThumbStyle,
      rootStyle = _useMemo.rootStyle,
      trackStyle = _useMemo.trackStyle,
      innerTrackStyle = _useMemo.innerTrackStyle;

  var focusThumb = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (index) {
    var idx = index != null ? index : activeIndex;

    if (idx !== -1 && focusThumbOnChange) {
      var _rootRef$current2;

      var id = ids.getThumb(idx);
      var thumb = (_rootRef$current2 = rootRef.current) == null ? void 0 : _rootRef$current2.ownerDocument.getElementById(id);

      if (thumb) {
        setTimeout(function () {
          return (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .focus */ .T_)(thumb);
        });
      }
    }
  }, [focusThumbOnChange, activeIndex, ids]);
  (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useUpdateEffect */ .rf)(function () {
    if (eventSourceRef.current === "keyboard") {
      onChangeEnd == null ? void 0 : onChangeEnd(valueRef.current);
    }
  }, [value, onChangeEnd]);

  var _onPanSessionStart = function onPanSessionStart(event) {
    var pointValue = getValueFromPointer(event) || 0;
    var distances = value.map(function (val) {
      return Math.abs(val - pointValue);
    });
    var closest = Math.min.apply(Math, distances);
    var index = distances.indexOf(closest); // check if the clicked thumb is stacked by checking if there are multiple
    // thumbs at the same distance

    var thumbsAtPosition = distances.filter(function (distance) {
      return distance === closest;
    });
    var isThumbStacked = thumbsAtPosition.length > 1; // when two thumbs are stacked and the user clicks at a point larger than
    // their values, pick the last thumb with the greatest index

    if (isThumbStacked && pointValue > value[index]) {
      index = thumbsAtPosition.length - 1;
    }

    setActiveIndex(index);
    actions.setValueAtIndex(index, pointValue);
    focusThumb(index);
  };

  var _onPan = function onPan(event) {
    if (activeIndex == -1) return;
    var pointValue = getValueFromPointer(event) || 0;
    setActiveIndex(activeIndex);
    actions.setValueAtIndex(activeIndex, pointValue);
    focusThumb(activeIndex);
  };

  (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_1__/* .usePanGesture */ .PO)(rootRef, {
    onPanSessionStart: function onPanSessionStart(event) {
      if (!isInteractive) return;
      setDragging.on();

      _onPanSessionStart(event);

      onChangeStart == null ? void 0 : onChangeStart(valueRef.current);
    },
    onPanSessionEnd: function onPanSessionEnd() {
      if (!isInteractive) return;
      setDragging.off();
      onChangeEnd == null ? void 0 : onChangeEnd(valueRef.current);
    },
    onPan: function onPan(event) {
      if (!isInteractive) return;

      _onPan(event);
    }
  });
  var getRootProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (props, ref) {
    if (props === void 0) {
      props = {};
    }

    if (ref === void 0) {
      ref = null;
    }

    return _extends({}, props, htmlProps, {
      id: ids.root,
      ref: (0,_chakra_ui_react_utils__WEBPACK_IMPORTED_MODULE_3__/* .mergeRefs */ .lq)(ref, rootRef),
      tabIndex: -1,
      "aria-disabled": (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .ariaAttr */ .Qm)(isDisabled),
      "data-focused": (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .dataAttr */ .PB)(isFocused),
      style: _extends({}, props.style, rootStyle)
    });
  }, [htmlProps, isDisabled, isFocused, rootStyle, ids]);
  var getTrackProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (props, ref) {
    if (props === void 0) {
      props = {};
    }

    if (ref === void 0) {
      ref = null;
    }

    return _extends({}, props, {
      ref: (0,_chakra_ui_react_utils__WEBPACK_IMPORTED_MODULE_3__/* .mergeRefs */ .lq)(ref, trackRef),
      id: ids.track,
      "data-disabled": (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .dataAttr */ .PB)(isDisabled),
      style: _extends({}, props.style, trackStyle)
    });
  }, [isDisabled, trackStyle, ids]);
  var getInnerTrackProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (props, ref) {
    if (props === void 0) {
      props = {};
    }

    if (ref === void 0) {
      ref = null;
    }

    return _extends({}, props, {
      ref: ref,
      id: ids.innerTrack,
      style: _extends({}, props.style, innerTrackStyle)
    });
  }, [innerTrackStyle, ids]);
  var getThumbProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (props, ref) {
    var _getAriaValueText;

    if (ref === void 0) {
      ref = null;
    }

    var index = props.index,
        rest = _objectWithoutPropertiesLoose(props, _excluded2);

    var _value = value[index];

    if (_value == null) {
      throw new TypeError("[range-slider > thumb] Cannot find value at index `" + index + "`. The `value` or `defaultValue` length is : " + value.length);
    }

    var bounds = valueBounds[index];
    return _extends({}, rest, {
      ref: ref,
      role: "slider",
      tabIndex: isInteractive ? 0 : undefined,
      id: ids.getThumb(index),
      "data-active": (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .dataAttr */ .PB)(isDragging && activeIndex === index),
      "aria-valuetext": (_getAriaValueText = getAriaValueText == null ? void 0 : getAriaValueText(_value)) != null ? _getAriaValueText : ariaValueText == null ? void 0 : ariaValueText[index],
      "aria-valuemin": bounds.min,
      "aria-valuemax": bounds.max,
      "aria-valuenow": _value,
      "aria-orientation": orientation,
      "aria-disabled": (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .ariaAttr */ .Qm)(isDisabled),
      "aria-readonly": (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .ariaAttr */ .Qm)(isReadOnly),
      "aria-label": ariaLabel == null ? void 0 : ariaLabel[index],
      "aria-labelledby": ariaLabel != null && ariaLabel[index] ? undefined : ariaLabelledBy == null ? void 0 : ariaLabelledBy[index],
      style: _extends({}, props.style, getThumbStyle(index)),
      onKeyDown: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .callAllHandlers */ .v0)(props.onKeyDown, onKeyDown),
      onFocus: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .callAllHandlers */ .v0)(props.onFocus, function () {
        setFocused.on();
        setActiveIndex(index);
      }),
      onBlur: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .callAllHandlers */ .v0)(props.onBlur, function () {
        setFocused.off();
        setActiveIndex(-1);
      })
    });
  }, [ids, value, valueBounds, isInteractive, isDragging, activeIndex, getAriaValueText, ariaValueText, orientation, isDisabled, isReadOnly, ariaLabel, ariaLabelledBy, getThumbStyle, onKeyDown, setFocused]);
  var getOutputProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (props, ref) {
    if (props === void 0) {
      props = {};
    }

    if (ref === void 0) {
      ref = null;
    }

    return _extends({}, props, {
      ref: ref,
      id: ids.output,
      htmlFor: value.map(function (v, i) {
        return ids.getThumb(i);
      }).join(" "),
      "aria-live": "off"
    });
  }, [ids, value]);
  var getMarkerProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (props, ref) {
    if (props === void 0) {
      props = {};
    }

    if (ref === void 0) {
      ref = null;
    }

    var _props = props,
        v = _props.value,
        rest = _objectWithoutPropertiesLoose(_props, _excluded3);

    var isInRange = !(v < min || v > max);
    var isHighlighted = v >= value[0] && v <= value[value.length - 1];
    var percent = (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .valueToPercent */ .Rg)(v, min, max);
    percent = isReversed ? 100 - percent : percent;

    var markerStyle = _extends({
      position: "absolute",
      pointerEvents: "none"
    }, orient$1({
      orientation: orientation,
      vertical: {
        bottom: percent + "%"
      },
      horizontal: {
        left: percent + "%"
      }
    }));

    return _extends({}, rest, {
      ref: ref,
      id: ids.getMarker(props.value),
      role: "presentation",
      "aria-hidden": true,
      "data-disabled": (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .dataAttr */ .PB)(isDisabled),
      "data-invalid": (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .dataAttr */ .PB)(!isInRange),
      "data-highlighted": (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .dataAttr */ .PB)(isHighlighted),
      style: _extends({}, props.style, markerStyle)
    });
  }, [isDisabled, isReversed, max, min, orientation, value, ids]);
  var getInputProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (props, ref) {
    if (ref === void 0) {
      ref = null;
    }

    var index = props.index,
        rest = _objectWithoutPropertiesLoose(props, _excluded4);

    return _extends({}, rest, {
      ref: ref,
      id: ids.getInput(index),
      type: "hidden",
      value: value[index],
      name: Array.isArray(name) ? name[index] : name + "-" + index
    });
  }, [name, value, ids]);
  return {
    state: {
      value: value,
      isFocused: isFocused,
      isDragging: isDragging,
      getThumbPercent: function getThumbPercent(i) {
        return thumbPercents[i];
      },
      getThumbMinValue: function getThumbMinValue(i) {
        return valueBounds[i].min;
      },
      getThumbMaxValue: function getThumbMaxValue(i) {
        return valueBounds[i].max;
      }
    },
    actions: actions,
    getRootProps: getRootProps,
    getTrackProps: getTrackProps,
    getInnerTrackProps: getInnerTrackProps,
    getThumbProps: getThumbProps,
    getMarkerProps: getMarkerProps,
    getInputProps: getInputProps,
    getOutputProps: getOutputProps
  };
}

var getValueBounds = function getValueBounds(arr, min, max, spacing) {
  return arr.map(function (v, i) {
    var _min = i === 0 ? min : arr[i - 1] + spacing;

    var _max = i === arr.length - 1 ? max : arr[i + 1] - spacing;

    return {
      min: _min,
      max: _max
    };
  });
};

var _excluded$2 = ["getRootProps"];

var _createContext$1 = (0,_chakra_ui_react_utils__WEBPACK_IMPORTED_MODULE_3__/* .createContext */ .kr)({
  name: "SliderContext",
  errorMessage: "useSliderContext: `context` is undefined. Seems you forgot to wrap all slider components within <RangeSlider />"
}),
    RangeSliderProvider = _createContext$1[0],
    useRangeSliderContext = _createContext$1[1];

/**
 * The Slider is used to allow users to make selections from a range of values.
 * It provides context and functionality for all slider components
 *
 * @see Docs     https://chakra-ui.com/docs/form/slider
 * @see WAI-ARIA https://www.w3.org/TR/wai-aria-practices/#slider
 */
var RangeSlider = /*#__PURE__*/(0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .forwardRef */ .Gp)(function (props, ref) {
  var styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .useMultiStyleConfig */ .jC)("Slider", props);
  var ownProps = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .omitThemingProps */ .Lr)(props);

  var _useTheme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .useTheme */ .Fg)(),
      direction = _useTheme.direction;

  ownProps.direction = direction;

  var _useRangeSlider = useRangeSlider(ownProps),
      getRootProps = _useRangeSlider.getRootProps,
      context = _objectWithoutPropertiesLoose(_useRangeSlider, _excluded$2);

  var ctx = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function () {
    return _extends({}, context, {
      name: props.name
    });
  }, [context, props.name]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(RangeSliderProvider, {
    value: ctx
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .StylesProvider */ .Fo, {
    value: styles
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .chakra.div */ .m$.div, _extends({}, getRootProps({}, ref), {
    className: "chakra-slider",
    __css: styles.container
  }), props.children)));
});
RangeSlider.defaultProps = {
  orientation: "horizontal"
};

if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .__DEV__ */ .Ts) {
  RangeSlider.displayName = "RangeSlider";
}

/**
 * Slider component that acts as the handle used to select predefined
 * values by dragging its handle along the track
 */
var RangeSliderThumb = /*#__PURE__*/(0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .forwardRef */ .Gp)(function (props, ref) {
  var _useRangeSliderContex = useRangeSliderContext(),
      getThumbProps = _useRangeSliderContex.getThumbProps,
      getInputProps = _useRangeSliderContex.getInputProps,
      name = _useRangeSliderContex.name;

  var styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .useStyles */ .yK)();
  var thumbProps = getThumbProps(props, ref);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .chakra.div */ .m$.div, _extends({}, thumbProps, {
    className: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__.cx)("chakra-slider__thumb", props.className),
    __css: styles.thumb
  }), thumbProps.children, name && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", getInputProps({
    index: props.index
  })));
});

if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .__DEV__ */ .Ts) {
  RangeSliderThumb.displayName = "RangeSliderThumb";
}

var RangeSliderTrack = /*#__PURE__*/(0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .forwardRef */ .Gp)(function (props, ref) {
  var _useRangeSliderContex2 = useRangeSliderContext(),
      getTrackProps = _useRangeSliderContex2.getTrackProps;

  var styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .useStyles */ .yK)();
  var trackProps = getTrackProps(props, ref);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .chakra.div */ .m$.div, _extends({}, trackProps, {
    className: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__.cx)("chakra-slider__track", props.className),
    __css: styles.track,
    "data-testid": "chakra-range-slider-track"
  }));
});

if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .__DEV__ */ .Ts) {
  RangeSliderTrack.displayName = "RangeSliderTrack";
}

var RangeSliderFilledTrack = /*#__PURE__*/(0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .forwardRef */ .Gp)(function (props, ref) {
  var _useRangeSliderContex3 = useRangeSliderContext(),
      getInnerTrackProps = _useRangeSliderContex3.getInnerTrackProps;

  var styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .useStyles */ .yK)();
  var trackProps = getInnerTrackProps(props, ref);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .chakra.div */ .m$.div, _extends({}, trackProps, {
    className: "chakra-slider__filled-track",
    __css: styles.filledTrack
  }));
});

if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .__DEV__ */ .Ts) {
  RangeSliderFilledTrack.displayName = "RangeSliderFilledTrack";
}

/**
 * SliderMark is used to provide names for specific Slider
 * values by defining labels or markers along the track.
 *
 * @see Docs https://chakra-ui.com/slider
 */
var RangeSliderMark = /*#__PURE__*/(0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .forwardRef */ .Gp)(function (props, ref) {
  var _useRangeSliderContex4 = useRangeSliderContext(),
      getMarkerProps = _useRangeSliderContex4.getMarkerProps;

  var markProps = getMarkerProps(props, ref);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .chakra.div */ .m$.div, _extends({}, markProps, {
    className: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__.cx)("chakra-slider__marker", props.className)
  }));
});

if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .__DEV__ */ .Ts) {
  RangeSliderMark.displayName = "RangeSliderMark";
}

var _excluded$1 = ["min", "max", "onChange", "value", "defaultValue", "isReversed", "direction", "orientation", "id", "isDisabled", "isReadOnly", "onChangeStart", "onChangeEnd", "step", "getAriaValueText", "aria-valuetext", "aria-label", "aria-labelledby", "name", "focusThumbOnChange"];

/**
 * React hook that implements an accessible range slider.
 *
 * It is an alternative to `<input type="range" />`, and returns
 * prop getters for the component parts
 *
 * @see Docs     https://chakra-ui.com/docs/form/slider
 * @see WAI-ARIA https://www.w3.org/TR/wai-aria-practices-1.1/#slider
 */
function useSlider(props) {
  var _getAriaValueText;

  var _props$min = props.min,
      min = _props$min === void 0 ? 0 : _props$min,
      _props$max = props.max,
      max = _props$max === void 0 ? 100 : _props$max,
      onChange = props.onChange,
      valueProp = props.value,
      defaultValue = props.defaultValue,
      isReversedProp = props.isReversed,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? "ltr" : _props$direction,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? "horizontal" : _props$orientation,
      idProp = props.id,
      isDisabled = props.isDisabled,
      isReadOnly = props.isReadOnly,
      onChangeStartProp = props.onChangeStart,
      onChangeEndProp = props.onChangeEnd,
      _props$step = props.step,
      step = _props$step === void 0 ? 1 : _props$step,
      getAriaValueTextProp = props.getAriaValueText,
      ariaValueText = props["aria-valuetext"],
      ariaLabel = props["aria-label"],
      ariaLabelledBy = props["aria-labelledby"],
      name = props.name,
      _props$focusThumbOnCh = props.focusThumbOnChange,
      focusThumbOnChange = _props$focusThumbOnCh === void 0 ? true : _props$focusThumbOnCh,
      htmlProps = _objectWithoutPropertiesLoose(props, _excluded$1);

  var onChangeStart = (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackRef */ .W6)(onChangeStartProp);
  var onChangeEnd = (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackRef */ .W6)(onChangeEndProp);
  var getAriaValueText = (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackRef */ .W6)(getAriaValueTextProp);
  var isReversed = getIsReversed({
    isReversed: isReversedProp,
    direction: direction,
    orientation: orientation
  });
  /**
   * Enable the slider handle controlled and uncontrolled scenarios
   */

  var _useControllableState = (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useControllableState */ .Tx)({
    value: valueProp,
    defaultValue: defaultValue != null ? defaultValue : getDefaultValue(min, max),
    onChange: onChange
  }),
      computedValue = _useControllableState[0],
      setValue = _useControllableState[1];

  var _useBoolean = (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useBoolean */ .kt)(),
      isDragging = _useBoolean[0],
      setDragging = _useBoolean[1];

  var _useBoolean2 = (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useBoolean */ .kt)(),
      isFocused = _useBoolean2[0],
      setFocused = _useBoolean2[1];

  var eventSourceRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var isInteractive = !(isDisabled || isReadOnly);
  /**
   * Constrain the value because it can't be less than min
   * or greater than max
   */

  var value = (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .clampValue */ .HU)(computedValue, min, max);
  var valueRef = (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useLatestRef */ .II)(value);
  var prevRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(valueRef.current);
  var reversedValue = max - value + min;
  var trackValue = isReversed ? reversedValue : value;
  var thumbPercent = (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .valueToPercent */ .Rg)(trackValue, min, max);
  var isVertical = orientation === "vertical";
  /**
   * Let's keep a reference to the slider track and thumb
   */

  var trackRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var thumbRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var rootRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  /**
   * Generate unique ids for component parts
   */

  var _useIds = (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useIds */ .ZS)(idProp, "slider-thumb", "slider-track"),
      thumbId = _useIds[0],
      trackId = _useIds[1];
  /**
   * Get relative value of slider from the event by tracking
   * how far you clicked within the track to determine the value
   *
   * @todo - Refactor this later on to use info from pan session
   */


  var getValueFromPointer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (event) {
    var _event$touches$, _event$touches;

    if (!trackRef.current) return;
    eventSourceRef.current = "pointer";
    var trackRect = (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_5__/* .getBox */ .iz)(trackRef.current).borderBox;

    var _ref = (_event$touches$ = (_event$touches = event.touches) == null ? void 0 : _event$touches[0]) != null ? _event$touches$ : event,
        clientX = _ref.clientX,
        clientY = _ref.clientY;

    var diff = isVertical ? trackRect.bottom - clientY : clientX - trackRect.left;
    var length = isVertical ? trackRect.height : trackRect.width;
    var percent = diff / length;

    if (isReversed) {
      percent = 1 - percent;
    }

    var nextValue = (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .percentToValue */ .WS)(percent, min, max);

    if (step) {
      nextValue = parseFloat((0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .roundValueToStep */ .WP)(nextValue, min, step));
    }

    nextValue = (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .clampValue */ .HU)(nextValue, min, max);
    return nextValue;
  }, [isVertical, isReversed, max, min, step]);
  var tenSteps = (max - min) / 10;
  var oneStep = step || (max - min) / 100;
  var constrain = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (value) {
    if (!isInteractive) return;
    value = parseFloat((0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .roundValueToStep */ .WP)(value, min, oneStep));
    value = (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .clampValue */ .HU)(value, min, max);
    setValue(value);
  }, [oneStep, max, min, setValue, isInteractive]);
  var actions = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return {
      stepUp: function stepUp(step) {
        if (step === void 0) {
          step = oneStep;
        }

        var next = isReversed ? value - step : value + step;
        constrain(next);
      },
      stepDown: function stepDown(step) {
        if (step === void 0) {
          step = oneStep;
        }

        var next = isReversed ? value + step : value - step;
        constrain(next);
      },
      reset: function reset() {
        return constrain(defaultValue || 0);
      },
      stepTo: function stepTo(value) {
        return constrain(value);
      }
    };
  }, [constrain, isReversed, value, oneStep, defaultValue]);
  /**
   * Keyboard interaction to ensure users can operate
   * the slider using only their keyboard.
   */

  var onKeyDown = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (event) {
    var eventKey = (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .normalizeEventKey */ .uh)(event);
    var keyMap = {
      ArrowRight: function ArrowRight() {
        return actions.stepUp();
      },
      ArrowUp: function ArrowUp() {
        return actions.stepUp();
      },
      ArrowLeft: function ArrowLeft() {
        return actions.stepDown();
      },
      ArrowDown: function ArrowDown() {
        return actions.stepDown();
      },
      PageUp: function PageUp() {
        return actions.stepUp(tenSteps);
      },
      PageDown: function PageDown() {
        return actions.stepDown(tenSteps);
      },
      Home: function Home() {
        return constrain(min);
      },
      End: function End() {
        return constrain(max);
      }
    };
    var action = keyMap[eventKey];

    if (action) {
      event.preventDefault();
      event.stopPropagation();
      action(event);
      eventSourceRef.current = "keyboard";
    }
  }, [actions, constrain, max, min, tenSteps]);
  /**
   * ARIA (Optional): To define a human readable representation of the value,
   * we allow users pass aria-valuetext.
   */

  var valueText = (_getAriaValueText = getAriaValueText == null ? void 0 : getAriaValueText(value)) != null ? _getAriaValueText : ariaValueText;
  /**
   * Measure the dimensions of the thumb so
   * we can center it within the track properly
   */

  var thumbBoxModel = (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useDimensions */ .Di)(thumbRef);
  /**
   * Compute styles for all component parts.
   */

  var _useMemo = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    var _thumbBoxModel$border;

    var thumbRect = (_thumbBoxModel$border = thumbBoxModel == null ? void 0 : thumbBoxModel.borderBox) != null ? _thumbBoxModel$border : {
      width: 0,
      height: 0
    };
    return getStyles({
      isReversed: isReversed,
      orientation: orientation,
      thumbRects: [thumbRect],
      thumbPercents: [thumbPercent]
    });
  }, [isReversed, orientation, thumbBoxModel == null ? void 0 : thumbBoxModel.borderBox, thumbPercent]),
      getThumbStyle = _useMemo.getThumbStyle,
      rootStyle = _useMemo.rootStyle,
      trackStyle = _useMemo.trackStyle,
      innerTrackStyle = _useMemo.innerTrackStyle;

  var focusThumb = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    if (thumbRef.current && focusThumbOnChange) {
      setTimeout(function () {
        return (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .focus */ .T_)(thumbRef.current);
      });
    }
  }, [focusThumbOnChange]);
  (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useUpdateEffect */ .rf)(function () {
    focusThumb();

    if (eventSourceRef.current === "keyboard") {
      onChangeEnd == null ? void 0 : onChangeEnd(valueRef.current);
    }
  }, [value, onChangeEnd]);

  var setValueFromPointer = function setValueFromPointer(event) {
    var nextValue = getValueFromPointer(event);

    if (nextValue != null && nextValue !== valueRef.current) {
      setValue(nextValue);
    }
  };

  (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_1__/* .usePanGesture */ .PO)(rootRef, {
    onPanSessionStart: function onPanSessionStart(event) {
      if (!isInteractive) return;
      setDragging.on();
      focusThumb();
      setValueFromPointer(event);
      onChangeStart == null ? void 0 : onChangeStart(valueRef.current);
    },
    onPanSessionEnd: function onPanSessionEnd() {
      if (!isInteractive) return;
      setDragging.off();
      onChangeEnd == null ? void 0 : onChangeEnd(valueRef.current);
      prevRef.current = valueRef.current;
    },
    onPan: function onPan(event) {
      if (!isInteractive) return;
      setValueFromPointer(event);
    }
  });
  var getRootProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (props, ref) {
    if (props === void 0) {
      props = {};
    }

    if (ref === void 0) {
      ref = null;
    }

    return _extends({}, props, htmlProps, {
      ref: (0,_chakra_ui_react_utils__WEBPACK_IMPORTED_MODULE_3__/* .mergeRefs */ .lq)(ref, rootRef),
      tabIndex: -1,
      "aria-disabled": (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .ariaAttr */ .Qm)(isDisabled),
      "data-focused": (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .dataAttr */ .PB)(isFocused),
      style: _extends({}, props.style, rootStyle)
    });
  }, [htmlProps, isDisabled, isFocused, rootStyle]);
  var getTrackProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (props, ref) {
    if (props === void 0) {
      props = {};
    }

    if (ref === void 0) {
      ref = null;
    }

    return _extends({}, props, {
      ref: (0,_chakra_ui_react_utils__WEBPACK_IMPORTED_MODULE_3__/* .mergeRefs */ .lq)(ref, trackRef),
      id: trackId,
      "data-disabled": (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .dataAttr */ .PB)(isDisabled),
      style: _extends({}, props.style, trackStyle)
    });
  }, [isDisabled, trackId, trackStyle]);
  var getInnerTrackProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (props, ref) {
    if (props === void 0) {
      props = {};
    }

    if (ref === void 0) {
      ref = null;
    }

    return _extends({}, props, {
      ref: ref,
      style: _extends({}, props.style, innerTrackStyle)
    });
  }, [innerTrackStyle]);
  var getThumbProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (props, ref) {
    if (props === void 0) {
      props = {};
    }

    if (ref === void 0) {
      ref = null;
    }

    return _extends({}, props, {
      ref: (0,_chakra_ui_react_utils__WEBPACK_IMPORTED_MODULE_3__/* .mergeRefs */ .lq)(ref, thumbRef),
      role: "slider",
      tabIndex: isInteractive ? 0 : undefined,
      id: thumbId,
      "data-active": (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .dataAttr */ .PB)(isDragging),
      "aria-valuetext": valueText,
      "aria-valuemin": min,
      "aria-valuemax": max,
      "aria-valuenow": value,
      "aria-orientation": orientation,
      "aria-disabled": (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .ariaAttr */ .Qm)(isDisabled),
      "aria-readonly": (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .ariaAttr */ .Qm)(isReadOnly),
      "aria-label": ariaLabel,
      "aria-labelledby": ariaLabel ? undefined : ariaLabelledBy,
      style: _extends({}, props.style, getThumbStyle(0)),
      onKeyDown: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .callAllHandlers */ .v0)(props.onKeyDown, onKeyDown),
      onFocus: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .callAllHandlers */ .v0)(props.onFocus, setFocused.on),
      onBlur: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .callAllHandlers */ .v0)(props.onBlur, setFocused.off)
    });
  }, [isInteractive, thumbId, isDragging, valueText, min, max, value, orientation, isDisabled, isReadOnly, ariaLabel, ariaLabelledBy, getThumbStyle, onKeyDown, setFocused.on, setFocused.off]);
  var getMarkerProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (props, ref) {
    if (props === void 0) {
      props = {};
    }

    if (ref === void 0) {
      ref = null;
    }

    var isInRange = !(props.value < min || props.value > max);
    var isHighlighted = value >= props.value;
    var markerPercent = (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .valueToPercent */ .Rg)(props.value, min, max);

    var markerStyle = _extends({
      position: "absolute",
      pointerEvents: "none"
    }, orient({
      orientation: orientation,
      vertical: {
        bottom: isReversed ? 100 - markerPercent + "%" : markerPercent + "%"
      },
      horizontal: {
        left: isReversed ? 100 - markerPercent + "%" : markerPercent + "%"
      }
    }));

    return _extends({}, props, {
      ref: ref,
      role: "presentation",
      "aria-hidden": true,
      "data-disabled": (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .dataAttr */ .PB)(isDisabled),
      "data-invalid": (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .dataAttr */ .PB)(!isInRange),
      "data-highlighted": (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .dataAttr */ .PB)(isHighlighted),
      style: _extends({}, props.style, markerStyle)
    });
  }, [isDisabled, isReversed, max, min, orientation, value]);
  var getInputProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (props, ref) {
    if (props === void 0) {
      props = {};
    }

    if (ref === void 0) {
      ref = null;
    }

    return _extends({}, props, {
      ref: ref,
      type: "hidden",
      value: value,
      name: name
    });
  }, [name, value]);
  return {
    state: {
      value: value,
      isFocused: isFocused,
      isDragging: isDragging
    },
    actions: actions,
    getRootProps: getRootProps,
    getTrackProps: getTrackProps,
    getInnerTrackProps: getInnerTrackProps,
    getThumbProps: getThumbProps,
    getMarkerProps: getMarkerProps,
    getInputProps: getInputProps
  };
}

function orient(options) {
  var orientation = options.orientation,
      vertical = options.vertical,
      horizontal = options.horizontal;
  return orientation === "vertical" ? vertical : horizontal;
}
/**
 * The browser <input type="range" /> calculates
 * the default value of a slider by using mid-point
 * between the min and the max.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/range
 */


function getDefaultValue(min, max) {
  return max < min ? min : min + (max - min) / 2;
}

var _excluded = ["getInputProps", "getRootProps"];

var _createContext = (0,_chakra_ui_react_utils__WEBPACK_IMPORTED_MODULE_3__/* .createContext */ .kr)({
  name: "SliderContext",
  errorMessage: "useSliderContext: `context` is undefined. Seems you forgot to wrap all slider components within <Slider />"
}),
    SliderProvider = _createContext[0],
    useSliderContext = _createContext[1];

/**
 * The Slider is used to allow users to make selections from a range of values.
 * It provides context and functionality for all slider components
 *
 * @see Docs     https://chakra-ui.com/docs/form/slider
 * @see WAI-ARIA https://www.w3.org/TR/wai-aria-practices/#slider
 */
var Slider = /*#__PURE__*/(0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .forwardRef */ .Gp)(function (props, ref) {
  var styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .useMultiStyleConfig */ .jC)("Slider", props);
  var ownProps = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .omitThemingProps */ .Lr)(props);

  var _useTheme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .useTheme */ .Fg)(),
      direction = _useTheme.direction;

  ownProps.direction = direction;

  var _useSlider = useSlider(ownProps),
      getInputProps = _useSlider.getInputProps,
      getRootProps = _useSlider.getRootProps,
      context = _objectWithoutPropertiesLoose(_useSlider, _excluded);

  var rootProps = getRootProps();
  var inputProps = getInputProps({}, ref);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(SliderProvider, {
    value: context
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .StylesProvider */ .Fo, {
    value: styles
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .chakra.div */ .m$.div, _extends({}, rootProps, {
    className: "chakra-slider",
    __css: styles.container
  }), props.children, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", inputProps))));
});
Slider.defaultProps = {
  orientation: "horizontal"
};

if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .__DEV__ */ .Ts) {
  Slider.displayName = "Slider";
}

/**
 * Slider component that acts as the handle used to select predefined
 * values by dragging its handle along the track
 */
var SliderThumb = /*#__PURE__*/(0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .forwardRef */ .Gp)(function (props, ref) {
  var _useSliderContext = useSliderContext(),
      getThumbProps = _useSliderContext.getThumbProps;

  var styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .useStyles */ .yK)();
  var thumbProps = getThumbProps(props, ref);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .chakra.div */ .m$.div, _extends({}, thumbProps, {
    className: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__.cx)("chakra-slider__thumb", props.className),
    __css: styles.thumb
  }));
});

if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .__DEV__ */ .Ts) {
  SliderThumb.displayName = "SliderThumb";
}

var SliderTrack = /*#__PURE__*/(0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .forwardRef */ .Gp)(function (props, ref) {
  var _useSliderContext2 = useSliderContext(),
      getTrackProps = _useSliderContext2.getTrackProps;

  var styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .useStyles */ .yK)();
  var trackProps = getTrackProps(props, ref);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .chakra.div */ .m$.div, _extends({}, trackProps, {
    className: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__.cx)("chakra-slider__track", props.className),
    __css: styles.track
  }));
});

if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .__DEV__ */ .Ts) {
  SliderTrack.displayName = "SliderTrack";
}

var SliderFilledTrack = /*#__PURE__*/(0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .forwardRef */ .Gp)(function (props, ref) {
  var _useSliderContext3 = useSliderContext(),
      getInnerTrackProps = _useSliderContext3.getInnerTrackProps;

  var styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .useStyles */ .yK)();
  var trackProps = getInnerTrackProps(props, ref);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .chakra.div */ .m$.div, _extends({}, trackProps, {
    className: "chakra-slider__filled-track",
    __css: styles.filledTrack
  }));
});

if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .__DEV__ */ .Ts) {
  SliderFilledTrack.displayName = "SliderFilledTrack";
}

/**
 * SliderMark is used to provide names for specific Slider
 * values by defining labels or markers along the track.
 *
 * @see Docs https://chakra-ui.com/slider
 */
var SliderMark = /*#__PURE__*/(0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .forwardRef */ .Gp)(function (props, ref) {
  var _useSliderContext4 = useSliderContext(),
      getMarkerProps = _useSliderContext4.getMarkerProps;

  var markProps = getMarkerProps(props, ref);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .chakra.div */ .m$.div, _extends({}, markProps, {
    className: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__.cx)("chakra-slider__marker", props.className)
  }));
});

if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .__DEV__ */ .Ts) {
  SliderMark.displayName = "SliderMark";
}




/***/ }),

/***/ 98978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56168);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16166);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65618);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34237);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47386);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29237);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45966);



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var defaultData = {
  current: null,
  defaultCurrent: 1,
  defaultPage: 1,
  defaultPageSize: 10,
  disabled: false,
  hideOnSinglePage: false,
  itemRender: function itemRender() {
    return null;
  },
  pageSize: 0,
  pageNeighbours: 0,
  pageSizeOptions: [10, 20, 50, 100],
  paginationProps: null,
  responsive: false,
  showQuickJumper: false,
  showSizeChanger: null,
  showTotal: function showTotal() {
    return null;
  },
  simple: null,
  total: 0,
  onChange: function onChange() {
    return '';
  },
  onShowSizeChange: function onShowSizeChange() {
    return '';
  },
  size: 'md',
  rounded: 'md',
  baseStyles: null,
  activeStyles: null,
  hoverStyles: null,
  colorScheme: 'brand',
  focusRing: false,
  basePath: null
};
var PaginationContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({});

var usePaginationStyles = function usePaginationStyles(props) {
  var _React$useContext = react__WEBPACK_IMPORTED_MODULE_0__.useContext(PaginationContext),
      colorScheme = _React$useContext.colorScheme,
      rounded = _React$useContext.rounded,
      size = _React$useContext.size,
      baseStyles = _React$useContext.baseStyles,
      activeStyles = _React$useContext.activeStyles,
      hoverStyles = _React$useContext.hoverStyles;

  var activeStyle = activeStyles || {
    bg: (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .useColorModeValue */ .ff)(colorScheme + ".600", colorScheme + ".500"),
    color: (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .useColorModeValue */ .ff)('white', 'gray.200'),
    cursor: 'pointer'
  };
  var hoverStyle = {
    _hover: hoverStyles || activeStyle
  };
  var baseStyle = baseStyles || {
    rounded: rounded,
    bg: (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .useColorModeValue */ .ff)('white', 'gray.800'),
    color: (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .useColorModeValue */ .ff)('gray.700', 'gray.200'),
    userSelect: 'none'
  };

  var getSizeStyle = function getSizeStyle(size) {
    var styles = {};

    switch (size) {
      case 'xs':
        styles = {
          px: 2,
          fontSize: 'xs'
        };
        break;

      case 'sm':
        styles = {
          px: 3,
          py: 1,
          fontSize: 'sm'
        };
        break;

      case 'md':
        styles = {
          px: 4,
          py: 1,
          fontSize: 'md'
        };
        break;

      case 'lg':
        styles = {
          px: 5,
          py: 2,
          fontSize: 'lg'
        };
        break;
    }

    return styles;
  };

  var sizeStyle = getSizeStyle(size);
  var disabledStyle = {
    opacity: 0.6,
    cursor: 'not-allowed'
  };
  return _extends({}, sizeStyle, baseStyle, !props.disabled && hoverStyle, props.active && activeStyle, props.disabled && disabledStyle);
};

var handleResponsive = function handleResponsive(props) {
  var type = props.type,
      active = props.active,
      responsive = props.responsive;
  var show = true;

  switch (type) {
    case 'page':
      if (!active) show = false;else if (!responsive.activePage) show = false;
      break;
  }

  return !show && 'none';
};

var PagButton = function PagButton(props) {
  var _React$useContext = react__WEBPACK_IMPORTED_MODULE_0__.useContext(PaginationContext),
      responsive = _React$useContext.responsive,
      focusRing = _React$useContext.focusRing;

  var paginationStyles = usePaginationStyles(props);
  var display = {
    display: [responsive && handleResponsive(_extends({}, props, {
      responsive: responsive
    })), 'block']
  };
  var onClick = !props.disabled ? props.onClick : null;
  var href = props.href ? {
    href: props.href
  } : {};
  var focusRingStyles = {
    boxShadow: focusRing ? typeof focusRing === 'string' ? "0 0 0 3px " + focusRing : "0 0 0 3px rgba(66, 153, 225, 0.6)" : 'none'
  };
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, Object.assign({
    onClick: onClick,
    as: props.as,
    mx: 1,
    my: "auto"
  }, paginationStyles, {
    _first: {
      ml: 0
    },
    _last: {
      mr: 0
    },
    _focus: focusRingStyles,
    size: props.size
  }, display, href), props.children);
};

var LEFT_PAGE = 'LEFT';
var RIGHT_PAGE = 'RIGHT';
/**
 * Helper method for creating a range of numbers
 * range(1, 5) => [1, 2, 3, 4, 5]
 */

var range = function range(from, to, step) {
  if (step === void 0) {
    step = 1;
  }

  var i = from;
  var range = [];

  while (i <= to) {
    range.push(i);
    i += step;
  }

  return range;
};

var fetchPageNumbers = function fetchPageNumbers() {
  var props = react__WEBPACK_IMPORTED_MODULE_0__.useContext(PaginationContext);
  var totalPages = Math.ceil(props.total / props.pageSize);
  var currentPage = props.currentPage;
  var pageNeighbours = props.pageNeighbours;
  /**
   * totalNumbers: the total page numbers to show on the control
   * totalBlocks: totalNumbers + 2 to cover for the left(<) and right(>) controls
   */

  var totalNumbers = pageNeighbours * 2 + 3;
  var totalBlocks = totalNumbers + 2;

  if (totalPages > totalBlocks) {
    var startPage = Math.max(2, currentPage - pageNeighbours);
    var endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
    var pages = range(startPage, endPage);
    /**
     * hasLeftSpill: has hidden pages to the left
     * hasRightSpill: has hidden pages to the right
     * spillOffset: number of hidden pages either to the left or to the right
     */

    var hasLeftSpill = startPage > 2;
    var hasRightSpill = totalPages - endPage > 1;
    var spillOffset = totalNumbers - (pages.length + 1);

    switch (true) {
      // handle: (1) < {5 6} [7] {8 9} (10)
      case hasLeftSpill && !hasRightSpill:
        {
          var extraPages = range(startPage - spillOffset, startPage - 1);
          pages = [LEFT_PAGE].concat(extraPages, pages);
          break;
        }
      // handle: (1) {2 3} [4] {5 6} > (10)

      case !hasLeftSpill && hasRightSpill:
        {
          var _extraPages = range(endPage + 1, endPage + spillOffset);

          pages = [].concat(pages, _extraPages, [RIGHT_PAGE]);
          break;
        }
      // handle: (1) < {4 5} [6] {7 8} > (10)

      case hasLeftSpill && hasRightSpill:
      default:
        {
          pages = [LEFT_PAGE].concat(pages, [RIGHT_PAGE]);
          break;
        }
    }

    return [1].concat(pages, [totalPages]);
  }

  return range(1, totalPages);
};

var PaginationComp = function PaginationComp() {
  var props = react__WEBPACK_IMPORTED_MODULE_0__.useContext(PaginationContext);
  var totalPages = Math.ceil(props.total / props.pageSize);
  var prevRender = props.itemRender(props.currentPage, 'prev');
  var nextRender = props.itemRender(props.currentPage, 'next');
  var leftRender = props.itemRender(props.currentPage, 'backward');
  var rightRender = props.itemRender(props.currentPage, 'forward');
  var pageSizeRender = props.itemRender(props.pageSize, 'pageSize');
  var pageRender = props.itemRender(props.currentPage, 'page');
  var totalRender = props.showTotal(props.total);
  if (!totalPages || props.hideOnSinglePage && totalPages === 1) return null;
  var pages = fetchPageNumbers();

  var changePage = function changePage(page) {
    var currentPage = Math.max(0, Math.min(page, totalPages));
    props.setCurrentPage(currentPage);
    props.onChange(currentPage, totalPages, props.pageSize, props.total);
  };

  var gotoPage = function gotoPage(evt, page) {
    evt.preventDefault();
    changePage(page);
  };

  var fastBackward = function fastBackward(evt) {
    evt.preventDefault();
    var page = props.currentPage - props.pageNeighbours * 2 - 1;
    changePage(page);
  };

  var fastForward = function fastForward(evt) {
    evt.preventDefault();
    var page = props.currentPage + props.pageNeighbours * 2 + 1;
    changePage(page);
  };

  var backward = function backward(evt) {
    evt.preventDefault();
    changePage(props.currentPage - 1);
  };

  var forward = function forward(evt) {
    evt.preventDefault();
    changePage(props.currentPage + 1);
  };

  var changePageSize = function changePageSize(size) {
    props.setPageSize(size);
    props.onShowSizeChange(props.currentPage, size);
  };

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(props.currentPage),
      simplePage = _React$useState[0],
      setSimplePage = _React$useState[1];

  var _React$useState2 = react__WEBPACK_IMPORTED_MODULE_0__.useState(''),
      pageJumper = _React$useState2[0],
      setPageJumper = _React$useState2[1];

  var simplePageUpdate = function simplePageUpdate(e) {
    e.preventDefault();

    if (isNaN(simplePage)) {
      setSimplePage(props.currentPage);
    } else {
      props.setCurrentPage(Math.max(0, Math.min(simplePage, totalPages)));
    }
  };

  var pageJumperUpdate = function pageJumperUpdate(e) {
    e.preventDefault();

    if (isNaN(pageJumper)) {
      setPageJumper('');
    } else {
      props.setCurrentPage(Math.max(0, Math.min(pageJumper, totalPages)));
      setPageJumper('');
    }
  };

  var responsiveDisplay = function responsiveDisplay(type) {
    if (props.responsive) {
      if (typeof props.responsive !== 'boolean' && Object.keys(props.responsive).includes(type)) {
        return {
          display: 'block'
        };
      }

      return {
        display: ['none', 'block']
      };
    }

    return {};
  };

  var hrefLink = function hrefLink(page) {
    if (props.basePath && page > 0 && page !== props.currentPage) {
      return {
        href: "" + props.basePath + page
      };
    }

    return {};
  };

  return props.total > 0 ? react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, Object.assign({}, props.paginationProps || {
    w: 'full',
    justifyContent: 'center'
  }), totalRender !== null && react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .chakra.span */ .m$.span, Object.assign({
    mx: 1,
    my: "auto",
    fontSize: props.size
  }, responsiveDisplay('totalRender')), totalRender), props.simple ? react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, react__WEBPACK_IMPORTED_MODULE_0__.createElement("form", {
    onSubmit: simplePageUpdate
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Input */ .II, {
    textAlign: "center",
    isDisabled: props.disabled,
    my: "auto",
    size: props.size === 'lg' ? 'md' : props.size === 'xs' ? 'xs' : 'sm',
    w: props.size === 'lg' ? 50 : 10,
    value: simplePage,
    onChange: function onChange(e) {
      return setSimplePage(e.target.value);
    }
  })), react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .chakra.span */ .m$.span, {
    userSelect: "none",
    opacity: props.disabled ? 0.6 : 1,
    mx: 1,
    my: "auto",
    fontSize: props.size
  }, "/ 5")) : react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(PagButton, Object.assign({
    as: prevRender,
    disabled: props.currentPage === 1 || props.disabled,
    onClick: backward
  }, hrefLink(props.currentPage - 1), {
    size: props.size === 'lg' ? 'md' : props.size === 'xs' ? 'xs' : 'sm'
  }), !prevRender && '<'), pages.map(function (page, index) {
    if (page === 'LEFT') return react__WEBPACK_IMPORTED_MODULE_0__.createElement(PagButton, Object.assign({
      as: leftRender,
      key: index,
      onClick: fastBackward
    }, hrefLink(props.currentPage - props.pageNeighbours * 2 - 1), {
      size: props.size === 'lg' ? 'md' : props.size === 'xs' ? 'xs' : 'sm'
    }, responsiveDisplay('fastBackward'), {
      my: "auto"
    }), !leftRender && '<<');
    if (page === 'RIGHT') return react__WEBPACK_IMPORTED_MODULE_0__.createElement(PagButton, Object.assign({
      as: rightRender,
      key: index,
      onClick: fastForward
    }, hrefLink(props.currentPage + props.pageNeighbours * 2 + 1), {
      size: props.size === 'lg' ? 'md' : props.size === 'xs' ? 'xs' : 'sm'
    }, responsiveDisplay('fastForward'), {
      my: "auto"
    }), !rightRender && '>>');
    var active = page === props.currentPage;
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(PagButton, Object.assign({
      as: pageRender,
      disabled: props.disabled,
      active: active,
      key: "page-" + index,
      onClick: function onClick(evt) {
        return gotoPage(evt, page);
      }
    }, hrefLink(page), {
      size: props.size === 'lg' ? 'md' : props.size === 'xs' ? 'xs' : 'sm',
      type: "page"
    }), page);
  }), react__WEBPACK_IMPORTED_MODULE_0__.createElement(PagButton, Object.assign({
    as: nextRender,
    disabled: props.currentPage === totalPages || props.disabled,
    onClick: forward
  }, hrefLink(props.currentPage + 1), {
    size: props.size === 'lg' ? 'md' : props.size === 'xs' ? 'xs' : 'sm'
  }), !nextRender && '>')), props.showSizeChanger && react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Menu */ .v2, null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(PagMenuButton, {
    ml: 1,
    as: pageSizeRender,
    disabled: props.disabled,
    size: props.size === 'lg' ? 'md' : props.size === 'xs' ? 'xs' : 'sm'
  }, props.pageSize, " / page"), react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .MenuList */ .qy, null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .MenuOptionGroup */ .__, {
    onChange: changePageSize
  }, props.pageSizeOptions.filter(function (opt) {
    return opt !== props.pageSize;
  }).map(function (opt, oid) {
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .MenuItemOption */ .ii, {
      fontSize: props.size,
      value: opt.toString(),
      key: "size" + oid
    }, opt, " / page");
  })))), props.showQuickJumper && react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .HStack */ .Ug, Object.assign({
    as: "form",
    userSelect: "none",
    opacity: props.disabled ? 0.6 : 1,
    ml: 2,
    onSubmit: pageJumperUpdate
  }, responsiveDisplay('pageJumper')), react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
    wordBreak: "unset"
  }, "Go to:"), react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Input */ .II, {
    width: "50px",
    value: pageJumper,
    isDisabled: props.disabled,
    onChange: function onChange(e) {
      return setPageJumper(e.target.value);
    },
    size: props.size === 'lg' ? 'md' : props.size === 'xs' ? 'xs' : 'sm'
  }))) : null;
};

var PagMenuButton = function PagMenuButton(props) {
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .MenuButton */ .j2, Object.assign({
    as: PagButton
  }, props));
};

var methods = ['itemRender', 'setCurrentPage'];
var nonMethods = /*#__PURE__*/Object.keys(defaultData).filter(function (k) {
  return !methods.includes(k);
});
var filterProps = function filterProps(props) {
  var validProps = nonMethods.reduce(function (acc, nxt) {
    acc.push(props[nxt]);
    return acc;
  }, []);
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function () {
    return props;
  }, validProps);
};

var Pagination = function Pagination(props) {
  var allProps = _extends({}, defaultData, props);

  var _React$useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(allProps.current || allProps.defaultCurrent),
      currentPage = _React$useState[0],
      setCurrentPage = _React$useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    props.current && setCurrentPage(props.current);
  }, [props.current]);

  var _React$useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(allProps.pageSize > 0 ? allProps.pageSize : allProps.defaultPageSize),
      pageSize = _React$useState2[0],
      setPageSize = _React$useState2[1];

  var contextvalue = _extends({}, allProps);

  var value = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return _extends({}, contextvalue, {
      currentPage: currentPage,
      setCurrentPage: setCurrentPage,
      pageSize: pageSize,
      setPageSize: setPageSize
    });
  }, [filterProps(contextvalue), currentPage, pageSize]);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(PaginationContext.Provider, {
    value: value
  }, (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(PaginationComp, null));
};

/* harmony default export */ __webpack_exports__["Z"] = (Pagination);
//# sourceMappingURL=paginator.esm.js.map


/***/ })

}]);